import {Dictionary} from 'lodash'
import {FC} from 'react'

import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE, TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

import {Text, TextVariant} from '../content/Text'
import {IncludedBenefit, IncludedBenefitType} from './IncludedBenefit'

type BenefitsListProps = {
  title: string
  subtitle?: string
  benefits: IncludedBenefitType[]
  variables?: Dictionary<any>
}

export const BenefitsList: FC<React.PropsWithChildren<BenefitsListProps>> = ({
  title,
  subtitle,
  benefits,
  variables,
}) => {
  return (
    <>
      <Text variant={TextVariant.h2} align="center">
        {title}
      </Text>
      {subtitle && (
        <div className="description">
          <Text variant={TextVariant.text20} color={theme.palette.text.light} align="center">
            {subtitle}
          </Text>
        </div>
      )}
      <ul className="list">
        {benefits.map(({title, description, linkUrl, linkText}) => (
          <li key={title} className="item">
            <IncludedBenefit
              title={title}
              description={description}
              linkUrl={linkUrl}
              linkText={linkText}
              variables={variables}
            />
          </li>
        ))}
      </ul>

      <style jsx>{`
        .description {
          margin-top: ${theme.spacing[3.5]};
        }
        .list {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
        }
        .item {
          flex: 1 0 46%;
          max-width: 46%;
          margin-top: ${theme.spacing[7]};
        }
        .item:nth-child(even) {
          margin-left: ${theme.spacing[7]};
        }
        @media ${TABLET_SCREENSIZE} {
          .item {
            margin-top: ${theme.spacing[6]};
          }
          .item:nth-child(even) {
            margin-left: ${theme.spacing[6]};
          }
        }
        @media ${MOBILE_SCREENSIZE} {
          .item {
            flex: 1 0 100%;
            max-width: inherit;
            margin-top: ${theme.spacing[5.5]};
          }
          .item:nth-child(even) {
            margin-left: 0;
          }
        }
      `}</style>
    </>
  )
}
